<template>
  <v-text-field flat
    v-model="filterText"
    :label="$t('general.search')"
    solo dense hide-details @input="onFilterChange($event)"
    @blur="onBlur()"
  ></v-text-field>
</template>

<script>
import {normalizeCaseAndAccents}  from '../../utils/functions';
import * as _ from "lodash";
import * as moment from 'moment';

export default {
  name: 'GeneralFilter',
  components: {
  },
  data () {
    return {
      filterText:null
    }
  },
  props: {
    items:{
      type: Array,
      default: []
    },
    minLength:{
      type: Number,
      default: 3
    },
    excludedFields:{
      type: Array,
      default: function () {
        return [];
      }
    },
    exactCoincidence:{
      type:Boolean,
      default: false
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    onFilterChange(filter){
      if(_.size(filter) > this.minLength){
        let filterSplitted = _.split(filter,' ');
        let filteredItems = _.filter(this.items,(i) => {
          return _.some(_.keys(i),(k) => {
            if(!_.includes(this.excludedFields,k)){
              if(!this.exactCoincidence){
                return _.some(filterSplitted,(f) => _.includes(normalizeCaseAndAccents(i[k]),normalizeCaseAndAccents(f)))
              }else{
                return _.includes(normalizeCaseAndAccents(i[k]),normalizeCaseAndAccents(filter))
              }
            }
            return false;
          });
        })
        this.$emit('filterChange',filteredItems);
      }else{
        this.$emit('filterChange',[]);
      }
      this.$emit('inputChange',filter);
    },
    onBlur(){
      this.$emit('blur',this.filterText);
    }
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/base/GeneralFilter.vue